import { ChartStatusFilter } from "../../../services/medicationmanagement/patientApi/models/ChartStatusFilter";
import { CourseExpiryFilterSubType, ExpiryFilterType } from "../../../services/medicationmanagement/patientApi/models/ExpiryFilterType";
import { FilterStatus } from "./FilterStatus";


export enum OrganizationAndFacilityType {
    All = 'All',
    Organization = 'Organization',
    Facility = 'Facility'
}

export enum FilterActions {
    ChangeName = 'ChangeName',
    ChangeItemsPerPage = 'ChangeItemsPerPage',
    ChangeCurrentPage = 'ChangeCurrentPage',
    Clear = 'Clear',
    ChangeResidentStatus = 'ChangeResidentStatus',
    ChangeChartExpiry = 'ChangeChartExpiry',
    CHANGE_CHART_EXPIRY_SUB_FILTER = 'CHANGE_CHART_EXPIRY_SUB_FILTER',
    CHANGE_CHART_STATUS = 'CHANGE_CHART_STATUS',
    CHANGE_ORGANIZATION_FACILITY = 'CHANGE_ORGANIZATION_FACILITY'
}
export interface IResidentFilter {
    key: number;
    itemsPerPage: number;
    name: string;
    selectedPage: number;
    residentStatus: FilterStatus;
    expiryFilterType: ExpiryFilterType;
    courseExpiryFilterSubType: CourseExpiryFilterSubType;
    chartStatus?: ChartStatusFilter;
    facilities:{type:OrganizationAndFacilityType,id:string|null};
}


export function filterReducer(state: IResidentFilter, action: [type: FilterActions, payload: any]): IResidentFilter {
    let [type, payload] = action;
    switch (type) {
        case FilterActions.ChangeName:
            return {
                ...state,
                name: payload,
                selectedPage: 1
            };
        case FilterActions.ChangeItemsPerPage:
            return {
                ...state,
                itemsPerPage: payload,
                selectedPage: 1
            };
        case FilterActions.ChangeCurrentPage:
            return {
                ...state,
                selectedPage: payload
            };
        case FilterActions.Clear:
            return {
                ...state,
                key: state.key + 1,
                selectedPage: 1,
                itemsPerPage: 25,
                name: '',
                residentStatus: FilterStatus.Active,
                expiryFilterType: ExpiryFilterType.All,
                courseExpiryFilterSubType: CourseExpiryFilterSubType.CourseExpiryInSevenDays,
                facilities:{type:OrganizationAndFacilityType.All,id:null},
                ...(payload||{})
            };
            
        case FilterActions.ChangeResidentStatus:
            return {
                ...state,
                selectedPage: 1,
                residentStatus: payload
            };
        case FilterActions.ChangeChartExpiry:
            return {
                ...state,
                selectedPage: 1,
                expiryFilterType: payload
            };
        case FilterActions.CHANGE_CHART_EXPIRY_SUB_FILTER:
            return {
                ...state,
                selectedPage: 1,
                expiryFilterType: ExpiryFilterType.CourseDueNowOrSoon,
                courseExpiryFilterSubType: payload
            };
        case FilterActions.CHANGE_CHART_STATUS:
            return {
                ...state,
                chartStatus: payload,
                selectedPage: 1
            };
        case FilterActions.CHANGE_ORGANIZATION_FACILITY:
            return {
                ...state,
                facilities: payload,
                selectedPage: 1
            };
    }
}